/* eslint-disable camelcase */
import React, { Suspense, useContext } from 'react';
import PropTypes from 'prop-types';
import { Context } from '~context/MainProvider.js';
import { getCard } from '../../../../helpers/cards';
import AdminButton from '../../../atoms/admin/card/button';
import styles from './cards.module.scss';
import Card from '~atoms/cards/default-card';
import keygen from '~helpers/keygen';

const Cards = ({ module, page, modulePosition }) => {
  const CustomCardComponent = getCard(module?.model_type || module?.cards_page_type);
  const { admin } = useContext(Context) || {};

  return (
    <div className={styles.cardsContainer}>
      {module.items &&
        module.items.map((item, index) =>
          CustomCardComponent ? (
            <Suspense fallback={<></>}>
              {admin ? (
                <div className={styles.container}>
                  <AdminButton item={item} />
                  <CustomCardComponent
                    key={keygen()}
                    featured={module.style === 'featured'}
                    item={item}
                    type={item.type}
                    number={index + 1}
                    page={page}
                    modulePosition={modulePosition}
                    itemPosition={index + 1}
                  />
                </div>
              ) : (
                <CustomCardComponent
                  key={keygen()}
                  featured={module.style === 'featured'}
                  item={item}
                  type={item.type}
                  number={index + 1}
                  page={page}
                  modulePosition={modulePosition}
                  itemPosition={index + 1}
                />
              )}
            </Suspense>
          ) : (
            <Card
              key={keygen()}
              item={item}
              modulePosition={modulePosition}
              itemPosition={index + 1}
            />
          )
        )}
    </div>
  );
};

Cards.propTypes = {
  module: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types
    items: PropTypes.arrayOf(PropTypes.object),
    featured_index: PropTypes.number,
    style: PropTypes.string,
    cards_page_type: PropTypes.string,
    model_type: PropTypes.string,
  }).isRequired,
  page: PropTypes.shape({}),
  modulePosition: PropTypes.number,
};

export default Cards;
